import { render, staticRenderFns } from "./OtherReciveList.vue?vue&type=template&id=0e480f4b&scoped=true&"
import script from "./OtherReciveList.vue?vue&type=script&lang=js&"
export * from "./OtherReciveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e480f4b",
  null
  
)

export default component.exports